import { render } from "./HeaderLang.vue?vue&type=template&id=7b4be5be&scoped=true"
import script from "./HeaderLang.vue?vue&type=script&lang=js"
export * from "./HeaderLang.vue?vue&type=script&lang=js"

import "./HeaderLang.vue?vue&type=style&index=0&id=7b4be5be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b4be5be"]])

export default __exports__